/*
 * Copyright (c) to Energy Analytics & Solutions Pty Ltd. All rights reserved.
 */
/* Author: Nikhil
   Purpose: "Meet EA&S" section on homepage
   Date: 5th January 2023
***************************************************************************
Changes/ enhancements
16-JAN-2024 EAS-439: Change book a demo link to hubspot from calendly - Nikhil P
***************************************************************************
*/
import React from 'react'
// import './MeetEAS.css'
const MeetEAS = () => {
    return (
        <>
            {/* <div className="whatwedo">
                <div className="wwdFirst">
                    <h1>MEET EA&S</h1>
                    <center></center>
                </div>
                <div className="measSecond">
                    <div className="measSecondLeft">
                        <div className='measSecondLeftText'>
                            <h3>HI, WE’RE EA&S. A FAST GROWING AND PROGRESSIVE AUSTRALIAN BASED ENERGY SOLUTIONS COMPANY ON A MISSION.</h3>
                            <p>To make energy management and optimisation easy for everyone. And we won’t stop until every building in Australia has net-zero carbon emission.  </p>
                        </div>
                    </div>
                    <div className="measSecondRight">
                        <div className='measSecondRightText'>
                            <p>To make this happen, our team of experts partner with your organisation, using real-time enriched data and a wealth of electrical engineering expertise, to help you easily and accurately optimise your energy use and reduce your carbon footprint.</p>
                            <p>Our goal is an audacious one. Nothing less than helping you to become 100% self-reliant when it comes to energy, and, in doing so, help the environment. </p>
                            <p>So if you want to start making a positive difference, it’s as easy as EA&S.</p>
                            <button className="measSecondRightButton"><a href="https://meetings.hubspot.com/ashley-mahadeo" target="_blank" rel="noreferrer" >WANNA KNOW MORE?</a></button>
                        </div>
                    </div>
                </div>
            </div> */}
            <div className='row px-4 mb-5'>
                <div className="wwdFirst">
                    <h1>MEET EA&S</h1>
                </div>
                <div className='col-sm-6'>
                    <div className="measSecondLeft">
                        <div className='measSecondLeftText'>
                            <h3>HI, WE’RE EA&S. A FAST GROWING AND PROGRESSIVE AUSTRALIAN BASED ENERGY SOLUTIONS COMPANY ON A MISSION.</h3>
                            <p>To make energy management and optimisation easy for everyone. And we won’t stop until every building in Australia has net-zero carbon emission.  </p>
                        </div>
                    </div>
                </div>
                <div className='col-sm-6'>
                    <div className='measSecondRightText'>
                        <p>To make this happen, our team of experts partner with your organisation, using real-time enriched data and a wealth of electrical engineering expertise, to help you easily and accurately optimise your energy use and reduce your carbon footprint.</p>
                        <p>Our goal is an audacious one. Nothing less than helping you to become 100% self-reliant when it comes to energy, and, in doing so, help the environment. </p>
                        <p>So if you want to start making a positive difference, it’s as easy as EA&S.</p>
                        {/* ********************************EAS-439 Start************************************* */}
                        {/* <button className="measSecondRightButton"><a href="https://calendly.com/energyanalyticssolutions/book-a-time-with-ash" target="_blank" rel="noreferrer" >WANNA KNOW MORE?</a></button> */}
                        <button className="measSecondRightButton"><a href="https://meetings.hubspot.com/ashley-mahadeo" target="_blank" rel="noreferrer" >WANNA KNOW MORE?</a></button>
                        {/* ********************************EAS-439 End************************************* */}
                    </div>
                </div>

            </div>
        </>

    )
}

export default MeetEAS

/*
 * Copyright (c) to Energy Analytics & Solutions Pty Ltd. All rights reserved.
 */